import { analyticsPlugin } from './plugins/mainPlugin';
import { Env } from './plugins/types';
import Analytics from 'analytics';

export const analyticsInstance = Analytics({
  app: 'dashboard-vivus-es',
  version: '1.0.0',
  plugins: [
    ...(import.meta.env.VITE_ANALYTICS_ENABLED === 'true' &&
    import.meta.env.VITE_ANALYTICS_API
      ? [
          analyticsPlugin({
            url: import.meta.env.VITE_ANALYTICS_API as string,
            app: {
              applicationType: 'repeated',
              env: import.meta.env.VITE_ENV as Env,
              type: 'web',
              version: '1.0.0',
            },
            dequeueInterval: 1000,
            onFetchError: (err) => {
              // eslint-disable-next-line no-console
              console.error(
                `Analytics event failed to fetch: ${JSON.stringify(
                  err,
                  null,
                  2,
                )}`,
              );
            },
          }),
        ]
      : []),
  ],
});
